import { apiRequest } from './api';

export type ExternalAuthProvider = 'google' | 'microsoft' | 'twitter' | 'apple' | 'sso';
export type ExternalAuthDevice = 'web' | 'ios' | 'desktop';

export interface ExternalAuthResponse {
  token: string;
  redirect: string;
}

export function getExternalAuthURL(
  provider: ExternalAuthProvider,
  device: ExternalAuthDevice,
  type?: string,
  redirectPath: string = '/',
  appPath: string = '',
): Promise<ExternalAuthResponse> {
  const redirectUrl =
    device === 'web'
      ? `&redirect_url=${encodeURIComponent(`${window.location.origin}${redirectPath}`)}`
      : '';
  const appPathUrl = device === 'web' ? '' : `&path=${encodeURIComponent(appPath)}`;
  return apiRequest<ExternalAuthResponse>(
    'GET',
    `/users/auth/${provider}/?device=${device}${
      type ? `&type=${type}` : ''
    }${redirectUrl}${appPathUrl}`,
    undefined,
    {
      noTimeZone: true,
    },
  ).then((response) => response);
}

export function openUrlOutsideElectron(url: string): void {
  const a = document.createElement('a');
  a.target = '_blank';
  a.href = url;
  a.click();
}
